import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import kebabCase from 'lodash/kebabCase';

import { Location } from 'models/locations';
import { AddOns as AddOnsModel } from 'models/addons';

import Category from 'components/checkout/add-ons/category';

const propTypes = {
  addOns: PropTypes.shape({ general: PropTypes.instanceOf(List) }).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  selectedAddOns: PropTypes.instanceOf(AddOnsModel),
  handleSelectedAddOn: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedAddOns: new AddOnsModel(),
};

const OptionalAddOns = ({
  addOns,
  location,
  selectedAddOns,
  handleSelectedAddOn,
}) => (
  Object.keys(addOns).map(addOnType => (
    <Category
      addOnType={addOnType}
      addOns={addOns[addOnType]}
      location={location}
      selectedAddOns={selectedAddOns}
      handleSelectedAddOn={handleSelectedAddOn}
      key={`oao-${kebabCase(addOnType)}`}
    />
  ))
);

OptionalAddOns.propTypes = propTypes;
OptionalAddOns.defaultProps = defaultProps;
export default OptionalAddOns;
